import store from '../store'
import dayjs from 'dayjs'
import { websocketConnection } from '../lib/WebSocket'
import uuid from 'uuid-random';

var seconds = 0
var minutes = 0
var hours = 0
var myInterval
var howmanytimersafunctioniscalled = 0

export default function callTriggers() {

  console.log("CALL TRIGGERS CALLEEDD")

 
  
  connect.contact(function(contact) {

    contact.onIncoming((data)=>{
      console.log("ON INCOMMING WORKING",data)
    })

    console.log("this is contact payload during CALL TRIGGER",contact)
    if (contact.getAgentConnection().getMediaType() === connect.MediaType.SOFTPHONE) {
        contact.onIncoming(function(contact) {
          console.log("onIncoming000")
        store.dispatch('call/updateCallState', 'INCOMING')
        store.dispatch('common/routePage', 'call')
      })

 

      contact.onConnecting(function(contact) {
        console.log("ADITH",contact)
        console.log('ONCONNECTING EVENT++++++======', store.getters.call_type)

     

        store.dispatch('call/updateQueueName', contact.getQueue().name)

        store.dispatch('call/updateCallState', 'CONNECTING')
        store.dispatch('common/routePage', 'call')

      
        store.dispatch('call/updateExternalId',Date.now().toString(36) + Math.random().toString(36).substr(2));
          


        var activeConnection = contact.getActiveInitialConnection()
        console.log("THIS IS ACTIVE CONNECTION",activeConnection)
        var contactId = activeConnection['contactId']
        var connectionId = activeConnection['connectionId']
        var conn = new connect.Connection(contactId, connectionId)
        
        conn.getEndpoint().phoneNumber

        store.dispatch(
          'call/updateCallerNumber',
          conn.getEndpoint().phoneNumber
        )

        console.log("THISI S GET ATTRIBUTES",contact.getAttributes())

        store.dispatch('call/setContactId', contactId)
        // websocketConnection(contactId)
        console.log('ONCONNECTINGXXXXXXXXX+++++')

        // store.dispatch('call/setContactAttributes', contact.getAttributes())
        store.dispatch('notes/setNotes', contact.getAttributes())

      if(store.getters.freshchat_connecting_lock_flag == false){
       if(store.getters.outboundCall == false){
        let passData = {}

        passData.action = 'CALL_CONNECTING'
        passData.callDirection = "INCOMING_CALL"
        passData.amazonConnectChannelId = store.getters.freshchat_channel_id;
        passData.agentId = store.getters.agent_username
        passData.callerName = store.getters.caller_name
        passData.callerNumber = store.getters.caller_number
        passData.callerId = store.getters.caller_id
        passData.contactAttributes = store.getters.contact_attributes
        passData.calledTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
        passData.contactId = contactId;
        console.log(passData)
        parent.postMessage(passData, '*')
        console.log('on connecting ---------')
        store.dispatch('call/setFreshchatConnectingLock',true);
       }else{
        let passData = {}
        passData.action = 'CALL_CONNECTING'
        passData.callDirection = "OUTGOING_CALL"
        passData.amazonConnectChannelId = store.getters.freshchat_channel_id;
        passData.agentId = store.getters.agent_username
        passData.callerName = store.getters.caller_name
        passData.callerNumber = store.getters.caller_number
        passData.callerId = store.getters.caller_id
        passData.contactAttributes = store.getters.contact_attributes
        passData.calledTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
        passData.contactId = contactId;
        console.log(passData)
        parent.postMessage(passData, '*')
        store.dispatch('call/setFreshchatConnectingLock',true);


       }
       }
      })

      contact.onAccepted(function(contact) {
        store.dispatch('common/routePage', 'call')
        console.log('on onAccepted ---------')
        store.dispatch('call/updateCallState', 'ACCEPTED')
        if(store.getters.freshchat_pickedup_lock_flag == false){
          if(store.getters.outboundCall == false){
        var messageData = {};
        messageData.action = "AGENT_PICKEDUP";
        messageData.callDirection = "INCOMING_CALL"
        messageData.amazonConnectChannelId = store.getters.freshchat_channel_id
        messageData.conversationId = store.getters.freshchat_conversation_id;
        messageData.channelId = store.getters.freshchat_channel_id;
        messageData.contactId = store.getters.contact_id;
        messageData.callType = store.getters.call_state;
        messageData.callerNumber = store.getters.caller_number;
        messageData.userId = store.getters.freshchat_user_id;
        messageData.freshchatAgentId = store.getters.freshchat_agent_id;
        console.log("AGENT_PICKED_UP_PASSDATA",messageData)
        parent.postMessage(messageData,'*');
        store.dispatch('call/setFreshchatPickedUpLock',true);
        }
      }
      // else{
      //   var messageData = {};
      //   messageData.action = "AGENT_PICKEDUP";
      //   messageData.callDirection = "OUTGOING_CALL"
      //   messageData.amazonConnectChannelId = store.getters.freshchat_channel_id
      //   messageData.conversationId = store.getters.freshchat_conversation_id;
      //   messageData.channelId = store.getters.freshchat_channel_id;
      //   messageData.contactId = store.getters.contact_id;
      //   messageData.callType = store.getters.call_state;
      //   messageData.callerNumber = store.getters.caller_number;
      //   messageData.userId = store.getters.freshchat_user_id;
      //   messageData.freshchatAgentId = store.getters.freshchat_agent_id;
      //   console.log("AGENT_PICKED_UP_PASSDATA",messageData)
      //   parent.postMessage(messageData,'*');
      //   store.dispatch('call/setFreshchatPickedUpLock',true);

      // }
      })

      contact.onConnected(function(contact) {
        var contactId = '';
        store.dispatch('common/routePage', 'call')

        console.log('on onConnected ---------', contact.getQueue())

        store.dispatch('call/updateCallState', 'CONNECTED')
        store.dispatch('call/updateOnDestroyedFlag', true)
        let startStatus = contact.getState()
        let startTime = JSON.stringify(startStatus.timestamp)
        console.log('SARTTIME', startTime)
        store.dispatch('call/updateStartTime', startTime)
        store.dispatch('call/updateCallLogFlag', true)
        if (store.getters.onSetTimerFlag == false) {
          store.dispatch('call/updateOnSetTimerFlag', true)
          startTimer()
          console.log('SET TIMER CALLED')
        }


      
        if (store.getters.outboundCall) {
        //send outbound call event to freshchat when call is connected with customer

        if(store.getters.freshchat_outboundcall_connected_lock == false){
          var messageData = {};
          messageData.action = "AGENT_PICKEDUP";
          messageData.callDirection = "OUTGOING_CALL"
          messageData.amazonConnectChannelId = store.getters.freshchat_channel_id
          messageData.conversationId = store.getters.freshchat_conversation_id;
          messageData.channelId = store.getters.freshchat_channel_id;
          messageData.contactId = store.getters.contact_id;
          messageData.callType = store.getters.call_state;
          messageData.callerNumber = store.getters.caller_number;
          messageData.userId = store.getters.freshchat_user_id;
          messageData.freshchatAgentId = store.getters.freshchat_agent_id;
          console.log("AGENT_PICKED_UP_PASSDATA",messageData)
          parent.postMessage(messageData,'*');
          store.dispatch('call/setFreshchatOutboundCallConnectedLock',true)
        
        }
   

          console.log("OUTBOUND CALL CONNECTED")
          console.log(contact.getAttributes())

          console.log('THIS IS BEING CALLLLLED==========')
          // store.dispatch('call/setContactAttributes', contact.getAttributes())
          store.dispatch('notes/setNotes', contact.getAttributes())
          store.dispatch('call/updateCallTypeName','outgoing')


          var activeConnection = contact.getActiveInitialConnection()
          console.log("THIS IS ACTIVE CONNECTION DURING OUTBOUNDCALL",activeConnection)
          contactId = activeConnection['contactId']
          // var connectionId = activeConnection['connectionId']

          let outboundPassData = {}
          outboundPassData.action = 'OUTBOUND_CALL_FRESHCHAT'
          outboundPassData.callerNumber = store.getters.caller_number;
          // passData.agentId = store.getters.agent_username
          // passData.callerName = store.getters.caller_name
          // passData.callerNumber = store.getters.caller_number
          // passData.callerId = store.getters.caller_id
          // passData.contactAttributes = store.getters.contact_attributes
          // passData.calledTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
          outboundPassData.contactId = contactId;
          console.log("OUTGOING_CALL_FRESHCHAT",outboundPassData)
          parent.postMessage(outboundPassData, '*')

          // let passData = {}
          // passData.action = 'CALL_LOGS'
          // passData.callType = 'outgoing'
          // passData.agentId = store.getters.agent_username
          // passData.callerName = store.getters.caller_name
          // passData.queueName = store.getters.queue_name
          // passData.callerNumber = store.getters.caller_number
          // passData.callerId = store.getters.caller_id
          // passData.calledTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
          // console.log(passData)
          // parent.postMessage(passData, '*')
          // store.dispatch('common/pushCallLogs', passData)

          // // to store ticket details in localstorage
          // passData = {}
          // passData.action = 'OUTGOING_CALL'
          // passData.agentId = store.getters.agent_username
          // passData.callerName = store.getters.caller_name
          // passData.callerNumber = store.getters.caller_number
          // passData.callerId = store.getters.caller_id
          // passData.contactAttributes = store.getters.contact_attributes
          // passData.calledTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
          // console.log(passData)
          // parent.postMessage(passData, '*')
          // store.dispatch('call/updateFsCallType', false)
        } else {
          store.dispatch('call/updateCallTypeName','incoming')
          var activeConnection = contact.getActiveInitialConnection();
          contactId = activeConnection['contactId'];
          let inboundPassData = {}
          inboundPassData.action = 'INBOUND_CALL_FRESHCHAT'
          inboundPassData.callerNumber = store.getters.caller_number;

          // passData.agentId = store.getters.agent_username
          // passData.callerName = store.getters.caller_name
          // passData.callerNumber = store.getters.caller_number
          // passData.callerId = store.getters.caller_id
          // passData.contactAttributes = store.getters.contact_attributes
          // passData.calledTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
          inboundPassData.contactId = contactId;
          console.log("INCOMING_CALL_FRESHCHAT",inboundPassData)
          parent.postMessage(inboundPassData, '*')
          // let passData = {}
          // passData.action = 'CALL_LOGS'
          // passData.callType = 'incoming'
          // passData.agentId = store.getters.agent_username
          // passData.callerName = store.getters.caller_name
          // passData.queueName = store.getters.queue_name
          // passData.callerNumber = store.getters.caller_number
          // passData.callerId = store.getters.caller_id
          // passData.calledTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
          // console.log(passData)
          // parent.postMessage(passData, '*')
          // store.dispatch('common/pushCallLogs', passData)
          // store.dispatch('call/updateFsCallType', true)
        }
      })

      contact.onMissed(function(contact) {
        store.dispatch('common/routePage', 'call')
        console.log('on onMissed ---------')
        store.dispatch('call/updateCallState', 'MISSED')

        if(store.getters.outboundCall == true){
          console.log("MISSED CALL BUT OUTGOING")
            let passData = {}
            passData.action = 'CALL_LOGS'
            passData.callType = 'outgoing'
            passData.agentId = store.getters.agent_username
            passData.callerName = store.getters.caller_name
            passData.callerNumber = store.getters.caller_number
            passData.callerId = store.getters.freshwork_crm_contact_id
            passData.calledTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
            console.log(passData)
            parent.postMessage(passData, '*')
            store.dispatch('common/pushCallLogs', passData)
            // store.dispatch("call/updateCallerName","Unknown Caller");
        }else{
          let passData = {}
            passData.action = 'CALL_LOGS'
            passData.callType = 'missed'
            passData.agentId = store.getters.agent_username
            passData.callerName = store.getters.caller_name
            passData.callerNumber = store.getters.caller_number
            passData.callerId = store.getters.freshwork_crm_contact_id
            passData.calledTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
            console.log(passData)
            parent.postMessage(passData, '*')
            store.dispatch('common/pushCallLogs', passData)
          
        }
        

        if(store.getters.freshchat_missed_lock_flag == false){
          var betaContactId = generateRandomUUID()
          if(store.getters.outboundCall == false){
              var messageData = {};
              messageData.callDirection = "INCOMING_CALL"
              messageData.action = "FRESHCHAT_CALL_MISSED";
              messageData.amazonConnectChannelId = store.getters.freshchat_channel_id;
              messageData.betaContactId = betaContactId;
              messageData.conversationId = store.getters.freshchat_conversation_id;
              messageData.channelId = store.getters.freshchat_channel_id;
              messageData.contactId = store.getters.contact_id;
              messageData.callType = store.getters.call_state;
              messageData.callerNumber = store.getters.caller_number;
              messageData.userId = store.getters.freshwork_crm_contact_mcr_id;
              messageData.freshchatAgentId = store.getters.freshchat_agent_id;
              messageData.conversationAppId = store.getters.freshchat_conversation_app_id;
              console.log("FRESHCHAT_CALL_MISSED",messageData)
              parent.postMessage(messageData,'*');
              store.dispatch('call/setFreshchatMissedLock',true);
            }else{
              var messageData = {};
              messageData.callDirection = "OUTGOING_CALL"
              messageData.action = "FRESHCHAT_CALL_MISSED";
              messageData.amazonConnectChannelId = store.getters.freshchat_channel_id;
              messageData.betaContactId = betaContactId;
              messageData.conversationId = store.getters.freshchat_conversation_id;
              messageData.channelId = store.getters.freshchat_channel_id;
              messageData.contactId = store.getters.contact_id;
              messageData.callType = store.getters.call_state;
              messageData.callerNumber = store.getters.caller_number;
              messageData.userId = store.getters.freshwork_crm_contact_mcr_id;
              messageData.freshchatAgentId = store.getters.freshchat_agent_id;
              messageData.conversationAppId = store.getters.freshchat_conversation_app_id;
              console.log("FRESHCHAT_CALL_MISSED",messageData)
              parent.postMessage(messageData,'*');
              store.dispatch('call/setFreshchatMissedLock',true);
            }
        }
      })

      contact.getInitialConnection().getState()

      contact.onEnded(function(contact) {
        console.log('on onEnded ---------')
        console.log(store.getters.caller_name)

        var thirdPartyConn = contact.getSingleActiveThirdPartyConnection();

        if(store.getters.call_type=="onlyThirdParty"){
          store.dispatch("call/setCallType","onlyThirdPartyEnded")
        }

        console.log("Third Party Connection Available check on ended",thirdPartyConn)


        if(store.getters.number_pad){
          this.store.dispatch("call/updateNumberPad", false);
        }


        if(store.getters.callSubNav == 'dialpad'){
          this.$store.dispatch("actions/callSubNavigation", "call");
        }

       

        if(store.getters.freshchat_endcall_lock_flag == false){
          if(store.getters.outboundCall == false){
            var messageData = {};
            messageData.action = "FRESHCHAT_CALL_ENDED";
            messageData.callDirection = "INCOMING_CALL"
            messageData.amazonConnectChannelId = store.getters.freshchat_channel_id
            messageData.conversationId = store.getters.freshchat_conversation_id;
            messageData.channelId = store.getters.freshchat_channel_id;
            messageData.contactId = store.getters.contact_id;
            messageData.callType = store.getters.call_state;
            messageData.callerNumber = store.getters.caller_number;
            messageData.isMissedCall = store.getters.freshchat_missed_lock_flag;

            // messageData.userId = store.getters.freshchat_user_id;
            messageData.userId = store.getters.freshwork_crm_contact_mcr_id;
            messageData.freshchatAgentId = store.getters.freshchat_agent_id;
            messageData.conversationAppId = store.getters.freshchat_conversation_app_id;
            console.log("FRESHCHAT_CALL_ENDED",messageData)
            parent.postMessage(messageData,'*');
            store.dispatch('call/setFreshchatEndCallLock',true);
            store.dispatch('call/setFreshchatConnectingLock',false);

          }else{
            var messageData = {};
            messageData.action = "FRESHCHAT_CALL_ENDED";
            messageData.callDirection = "OUTGOING_CALL"
            messageData.amazonConnectChannelId = store.getters.freshchat_channel_id
            messageData.conversationId = store.getters.freshchat_conversation_id;
            messageData.channelId = store.getters.freshchat_channel_id;
            messageData.contactId = store.getters.contact_id;
            messageData.callType = store.getters.call_state;
            messageData.callerNumber = store.getters.caller_number;
            messageData.isMissedCall = store.getters.freshchat_missed_lock_flag;
            // messageData.userId = store.getters.freshchat_user_id;
            messageData.userId = store.getters.freshwork_crm_contact_mcr_id;
            messageData.freshchatAgentId = store.getters.freshchat_agent_id;
            messageData.conversationAppId = store.getters.freshchat_conversation_app_id;
            console.log("FRESHCHAT_CALL_ENDED",messageData)
            parent.postMessage(messageData,'*');
            store.dispatch('call/setFreshchatEndCallLock',true);
            store.dispatch('call/setFreshchatConnectingLock',false);

          }
       




         
          }

        let callState = store.getters.call_state
        let millis = contact.getStateDuration()
        let endStatus = contact.getState()

        let endTime = JSON.stringify(endStatus.timestamp)
        store.dispatch('call/updateEndTime', endTime)
        console.log('THIS IS THE STATE DURATION', millis)
        if (callState != 'ACW' && callState != 'MISSED') {
          store.dispatch('call/updateCallState', 'ENDED')
         
        }

        if (store.getters.onSetTimerFlag == true) {
          store.dispatch('call/updateOnSetTimerFlag', false)
          stopTimer()
          console.log('STOP TIMER CALLED')
        }

      
      })

      contact.onACW(function(contact) {
        store.dispatch('common/routePage', 'call')
        console.log('on onACW ---------')
        store.dispatch('call/updateCallState', 'ACW')
        if(store.getters.number_pad){
          store.dispatch("call/updateNumberPad", false);
        }
        if(store.getters.callSubNav == 'dialpad'){
          store.dispatch("call/setCallType", "normal");
          store.dispatch("actions/callSubNavigation", "call");
        }
      })

      contact.onDestroy(function(contact) {
        store.dispatch('actions/setOutboundCall', false);
        console.log("ON DESTROYYYYYYYED",store.getters.homeSubNav)
        store.dispatch('call/updateFreshworksCrmOnDestroy','');
        if(store.getters.notes_editor == true){
          store.dispatch('call/updateNotesEditor', false)
        }

        if(store.getters.call_type == "onlyThirdPartyEnded"){
          store.dispatch('call/setCallType',"normal")
      }


        if(store.getters.callSubNav == 'dialpad'){
          this.$store.dispatch("actions/callSubNavigation", "call");
        }



        if(store.getters.freshchat_endcall_lock_flag == true){
            store.dispatch('call/setFreshchatEndCallLock',false);
            store.dispatch('call/setFreshchatPickedUpLock',false);
            store.dispatch('call/setFreshchatMissedLock',false);
            store.dispatch('call/setFreshchatOutboundCallConnectedLock',false)
            store.dispatch('call/setFreshchatConnectingLock',false);
            store.dispatch('call/updateFreshworksCrmOnDestroy','');
          }


     
       
        if (store.getters.call_log_flag == true) {
          console.log('I WAS CALLED AT onDestroyed===========')
         

          if(store.getters.fs_call_type == false){
              let passData = {};
              passData.action = "CALL_LOGS"
              passData.callType = store.getters.call_type_name;
              passData.agentId = store.getters.agent_username;
              passData.callerName = store.getters.caller_name;
              passData.callerNumber = store.getters.caller_number;
              passData.callerId = store.getters.freshwork_crm_contact_id;
              passData.calledTime = dayjs().format('YYYY-MM-DD HH:mm:ss');
              console.log("I WAS CALLED 0000008888",passData)
              parent.postMessage(passData,"*");
              store.dispatch("common/pushCallLogs", passData);

              // var messageData = {};
              // messageData.action = "FRESHCHAT_CALL_ENDED";
              // messageData.conversationId = store.getters.freshchat_conversation_id;
              // messageData.channelId = store.getters.freshchat_channel_id;
              // messageData.contactId = store.getters.contact_id;
              // messageData.callType = store.getters.call_state;
              // messageData.callerNumber = store.getters.caller_number;
              // messageData.userId = store.getters.freshchat_user_id;
              // messageData.freshchatAgentId = store.getters.freshchat_agent_id;
              // console.log("FRESHCHAT_CALL_ENDED",messageData)
              // parent.postMessage(messageData,'*');
              // store.dispatch('call/setFreshchatEndCallLock',true);
          }

          store.dispatch('call/updateCallLogFlag', false)
        }

       
        console.log('on onDestroy ---------')
        console.log(store.getters.caller_name)
        store.dispatch('call/updateCallState', 'DESTROYED')
        // store.dispatch('call/setCallType',"call");
        store.dispatch('call/setCallType',"normal");
        
        store.dispatch('common/routePage', 'home')
        // store.dispatch('call/updateOnboundFlag', false)
        if (store.getters.on_destroyed_flag == true) {
          let passData = {}
          passData.action = 'ENDED_CALL'
          passData.agentId = store.getters.agent_username
          passData.ticketId = store.getters.selectedTicket
          passData.contactId = store.getters.contact_id
          passData.callerName = store.getters.caller_name
          passData.QueueName = store.getters.queue_name
          passData.callerNumber = store.getters.caller_number
          passData.callerId = store.getters.caller_id
          passData.start_time = store.getters.start_time
          passData.end_time = store.getters.end_time
          passData.callDuration = store.getters.callDuration
          passData.callType = store.getters.fs_call_type
          passData.calledTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
          passData.DestroyedFlag = store.getters.on_destroyed_flag
          console.log(passData)
          parent.postMessage(passData, '*')
      
          store.dispatch('call/updateOnDestroyedFlag', false)
          store.dispatch('call/updateCountry',{country:"us",code:"+1"})
        } else {
          console.log('falseeeeeeee')
        }
       
      })
    }
  })
}

function startTimer() {
  console.log('TIMER STARTED')
  myInterval = setInterval(process, 1000)
}

function stopTimer() {
  console.log('TIMER STOPPED')
  clearInterval(myInterval)

  console.log(myInterval)

  var min = Math.floor(myInterval / 60)
  var sec = myInterval - min * 60
  var hrs = Math.floor(myInterval / 3600)
  sec = sec < 10 ? '0' + sec : JSON.stringify(sec)
  min = min < 10 ? '0' + min : JSON.stringify(min)
  hrs = hrs < 10 ? '0' + hrs : JSON.stringify(hrs)
  let callDuration = `${hrs}:${min}:${sec}`
  store.dispatch('call/updateCallDuration', callDuration)
  store.dispatch('call/updateHours', '00')
  store.dispatch('call/updateSeconds', '00')
  store.dispatch('call/updateMinutes', '00')
  myInterval = 0
  seconds = 0
  minutes = 0
  hours = 0
}

function process() {
  seconds += 1
  let displaySeconds = seconds < 10 ? '0' + seconds : JSON.stringify(seconds)
  let displayMinutes = minutes < 10 ? '0' + minutes : JSON.stringify(minutes)
  let displayHours = hours < 10 ? '0' + hours : JSON.stringify(hours)
  if (seconds > 59) {
    minutes += 1
    seconds = 0
  }
  if (minutes > 59) {
    hours += 1
    minutes = 0
    seconds = 0
  }
  store.dispatch('call/updateHours', displayHours)
  store.dispatch('call/updateSeconds', displaySeconds)
  store.dispatch('call/updateMinutes', displayMinutes)
}


function generateRandomUUID(){
  return uuid()
}
